import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { ExtensionGroupOption } from '../models/extension-group-option';
import { extensionGroupOptionSelectors } from '../state/extension-group-option.reducer';

@Component({
   providers: [
      {
         provide: LCS_SINGLE_SELECT_OPTIONS,
         useExisting: ExtensionGroupSelectComponent,
      },
   ],
   selector: 'ndt-extension-group-select',
   templateUrl: './extension-group-select.component.html',
   standalone: false,
})
export class ExtensionGroupSelectComponent extends LcsSingleSelectBase<ExtensionGroupOption> implements OnInit {
   extensionGroups: Observable<ExtensionGroupOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.extensionGroups = this.store.pipe(
         select(extensionGroupOptionSelectors.selectFilteredItems),
         this.itemsLoaded()
      );
   }

   displayWith(item: ExtensionGroupOption | null): string | null {
      if (!item) {
         return null;
      }
      return item.name;
   }

   trackBy(item: ExtensionGroupOption | null) {
      return item ? item.extensionGroupId : null;
   }
}
